import { atom } from "recoil";

export const barreDefilement = atom({
  key: "barreDefilement",
  default: 0,
});


export const CarouselData = atom({
  key: "CarouselData",
  default: [
    {
      image: "banniere1.jpg",
    },
    {
      image: "banniere2.jpg",
    },
    {
      image: "banniere3.jpg",
    },
  ],
});

// export const animationToSendEmail = atom({
//   key: "animationToSendEmail",
//   default: false
// })

